module.exports = __webpack_public_path__ + "img/logo_white.3c6b5701.svg";